import manageReservationTypes from './manageReservation.types';

const INITIAL_STATE = {
  data: {},
  isLoading: false,
  errorMessage: null,
  requestSuccess: false,
  packagesUpdated: null,
  isCabanaLoading: false,
  cabanaErrorMessage: false,
  cabanaRequestSuccess: false
};

const manageReservationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case manageReservationTypes.GET_MANAGERESERVATIONDETAILS_REQUEST:
      return { ...state, isLoading: true };
    case manageReservationTypes.FETCH_RESERVATION_ADD_ONS_REQUEST:
      return { ...state, isLoading: true };
    case manageReservationTypes.GET_MANAGERESERVATIONDETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: { ...state.data, ...action.response },
        errorMessage: null,
        packagesUpdated: action?.packagesUpdated ?? null
      };
    case manageReservationTypes.GET_MANAGERESERVATIONDETAILS_FAILURE:
    case manageReservationTypes.FETCH_RESERVATION_ADD_ONS_FAILURE:
      return { ...state, isLoading: false, data: {}, errorMessage: action.message };
    case manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: { ...state.data, ...action.response },
        addGuestsReservationObj: action.response,
        errorMessage: null
      };
    case manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR:
      return { ...state, isLoading: false, errorMessage: action.message };
    case manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_CLEAR:
      delete state.addGuestsReservationObj;
      return { ...state, isLoading: false, errorMessage: null };
    case manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR_CLEAR:
      return { ...state, isLoading: false, errorMessage: null };

    case manageReservationTypes.GET_RESERVATION_BY_ID_AND_LAST_NAME_SUCCESS:
      return { ...state, isLoading: false, data: { ...state.data, ...action.response }, errorMessage: null };
    case manageReservationTypes.FETCH_RESERVATION_ADD_ONS_SUCCESS:
      return { ...state, isLoading: false, data: { ...state.data, upsellAddOns: action.response }, errorMessage: null };

    case manageReservationTypes.CLEAR_MANAGERESERVATIONDETAILS:
      return { ...state, ...INITIAL_STATE };
    case manageReservationTypes.GET_COMPARISON_CHANGES_REQUEST:
      return { ...state, isLoading: true };
    case manageReservationTypes.GET_COMPARISON_CHANGES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: { ...state.data, comparisonChanges: action.response },
        errorMessage: null
      };
    case manageReservationTypes.GET_COMPARISON_CHANGES_FAILURE:
      return { ...state, isLoading: false, data: {}, errorMessage: action.message };
    case manageReservationTypes.GET_COMPARISON_CHANGES_CLEAN:
      delete state.data.comparisonChanges;
      return { ...state, isLoading: false, data: { ...state.data }, errorMessage: action.message };
    case manageReservationTypes.CLEAR_RESERVATION_PACKAGES_UPDATE:
      return { ...state, isLoading: false, packagesUpdated: null, errorMessage: null };
    case manageReservationTypes.FETCH_RESERVATION_DYNAMIC_TILE_SUCCESS:
      return { ...state, dynamicTile: action.response };
    case manageReservationTypes.CLEAR_RESERVATION_DETAILS_DETAILS_ERROR:
      return { ...state, errorMessage: null };
    case manageReservationTypes.RESERVATION_DETAILS_CABANA_IS_LOADING:
      return { ...state, isCabanaLoading: true };
    case manageReservationTypes.RESERVATION_DETAILS_CABANA_SUCCESS:
      return { ...state, isCabanaLoading: false, cabanaRequestSuccess: true };
    case manageReservationTypes.RESERVATION_DETAILS_CABANA_FAILURE:
      return { ...state, isCabanaLoading: false, cabanaErrorMessage: action.message };
    case manageReservationTypes.CLEAR_RESERVATION_DETAILS_CABANA_DETAILS:
      return { ...state, isCabanaLoading: false, cabanaErrorMessage: null, cabanaRequestSuccess: false };
    case manageReservationTypes.PACKAGE_RESERVATION_LOADING_ERROR:
      return { ...state, isLoading: false, packageErrorMessageData: action.message };
    case manageReservationTypes.CLEAR_RESERVATION_DETAILS_PACKAGE_MESSAGE_ERROR:
      return { ...state, packageErrorMessageData: null };
    case manageReservationTypes.CHANGE_RESERVATION_TYPE:
      return {
        ...state,
        reservationId: action.reservationId,
        data: {
          ...state.data,
          id: action.reservationId,
          reservationType: action.reservationType,
          arrival: action.startDate,
          departure: action.endDate
        }
      };
    default:
      return state;
  }
};

export default manageReservationReducer;
